import { createStyleSheet } from '@shared-ui/theme'
import { rh, rw } from '@shared-ui/theme/scale'

export const useCreateStyles = createStyleSheet((theme) => ({
  root: {
    backgroundColor: theme.COLOR_BG_SURFACE,
    borderRadius: rw(20),
    padding: rw(20),
    flexDirection: 'row',
    gap: rw(16),
    alignItems: 'flex-start',
  },
  cancelled: { backgroundColor: theme.COLOR_BG_BASE, borderWidth: rw(1), borderColor: theme.COLOR_STROKE_SECONDARY },
  content: { flex: 1, gap: rh(12) },
  cancelledContent: { gap: rh(16) },
  textBlock: { gap: rh(4) },
  cancelledText: { gap: rh(8) },
  title: { flexDirection: 'row', alignItems: 'center', gap: rw(8) },
}))
